import ConnectorConfigDialog from "./ConnectorConfigDialog";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const ConnectorConfigPropertiesPanel = ({formId, uiSchema, connectorConfigSchemaRequired, connectorConfigSchemaOptional, saveConnectorConfigData, formData, readOnly, handleFormChange }) => {
    return (
        <div>
            <Typography style={{fontWeight: 'bold'}}>Required Fields</Typography>
            <ConnectorConfigDialog formId={formId} uiSchema={uiSchema} connectorSchema={connectorConfigSchemaRequired}
              saveConnectorConfigData={saveConnectorConfigData} formData={formData}
              handleFormChange={handleFormChange} readOnly={readOnly}/>
              <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
              <Typography style={{fontWeight: 'bold'}}>Optional Fields</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <ConnectorConfigDialog id={formId} uiSchema={uiSchema} connectorSchema={connectorConfigSchemaOptional}
                    saveConnectorConfigData={saveConnectorConfigData} formData={formData}
                    handleFormChange={handleFormChange} readOnly={readOnly}/>
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>

    );
}

export default ConnectorConfigPropertiesPanel;